import React from 'react'
import { VideoCircle } from 'iconsax-react'
import { useTheme } from '@mui/material'

import CloseButton from '../CloseButton'

import useStyles from './styles'

const Video = ({ file, onDelete }) => {
  const theme = useTheme()

  const [hovering, setHovering] = React.useState(false)

  const classes = useStyles()

  return (
    <div
      onMouseEnter={() => setHovering(true)}
      onMouseLeave={() => setHovering(false)}
      className={classes.root}
    >
      <VideoCircle size={theme.size.xl} variant='Bold' color='white' />

      {hovering && <CloseButton onDelete={onDelete} />}
    </div>
  )
}

export default Video
